import React, { useState, useEffect } from "react";
import TopBar from "../topbar/TopBar";
import report from "../../assets/svg/reportimg.svg";
import previous from "../../assets/svg/previousexports.svg";
import save from "../../assets/svg/saveastemplate.svg";
import quick from "../../assets/svg/quick.svg";
import download from "../../assets/svg/downsave.svg";
import searchs from "../../assets/svg/searchs.svg";
import calendar from "../../assets/svg/calendar.svg";
import purpose from "../../assets/svg/target.svg";
import visitorbased from "../../assets/svg/visitorbased.svg";
import meeting from "../../assets/svg/meetingbased.svg";
import gate from "../../assets/svg/gatebased.svg";
import location from "../../assets/svg/location.svg";
import department from "../../assets/svg/department.svg";
import organization from "../../assets/svg/organization.svg";
import checklist from "../../assets/svg/checklist.svg";
import scheduled from "../../assets/svg/scheduled.svg";
import time from "../../assets/svg/maxtime.svg";
import courier from "../../assets/svg/courier.svg";
import vehicletype from "../../assets/svg/vehicle.svg";
import driver from "../../assets/svg/driverbased.svg";
import vehiclebased from "../../assets/svg/vehiclebased.svg";
import user from "../../assets/svg/userbased.svg";
import mytemp from "../../assets/svg/mytemplate.svg";
import drop from "../../assets/svg/dropdown.svg";
import SearchWithAPI from "../common/searchbox/selectbox2.js";
import "../../components/report/report.css";
import Select from "react-select";
import { downloadBase64File, exportdata, exportquickApi, getDownloadReportApi, getExportdownloadApis, getExportfieldApis, getquickreportApi, getTempalteApi, savetempalteApi } from "./report-api";
import DatePicker from "react-datepicker";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Toast, ToastContainer } from "react-bootstrap";
import TempalteModal from "../common/commonalert.js";
import { getExportfieldApi } from "./report-api";
import PoweredBy from "../common/poweredBy.jsx";

const Report = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  //report toggle button
  const [selected, setSelected] = useState("Customized");
  const [searchTerm, setSearchTerm] = useState("");
  //search-dropdown
  const [selectedMy, setSelectedMy] = useState(null);
  const [selectedPrev, setSelectedPrev] = useState(null);
  const [searchMy, setSearchMy] = useState("");
  const [searchPrev, setSearchPrev] = useState("");
  const [openMy, setOpenMy] = useState(false);
  const [openPrev, setOpenPrev] = useState(false);
  const [validations, setValidations] = useState({
    name: "",
    fields: "",
  });

  const [selectedType, setSelectedType] = useState("Visitor");

  const [selectedquick, setSelectedquick] = useState(null);
  const [selectedDepart, setSelectedDepart] = useState("");
  const [selectedlocation, setSelectedlocation] = useState("");
  const [selectedDatebasType, setSelectedDatebasType] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedpurpose, setSelectedpurpose] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedmeetPerson, setSelectedmeetPerson] = useState(null);
  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const [selectedOrgan, setSelectedOrgan] = useState(null);
  const [selectedGatebased, setSelectedGatebased] = useState(null);
  const [selectedMeetType, setSelectedMeetType] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [myTemplates, setmyTemplates] = useState([]);
  const [previousTemplates, setpreviousTemplates] = useState([]);
  const [reportOptions, setreportOptions] = useState([]);
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const StatusDropdown = () => {
    return (<div
      style={{
        width: "30%",
        gap: "8px",
      }}
    >
      <div
        style={{
          fontWeight: "500",
          fontSize: "13px", paddingBottom: '8px',
          color: "#172B4D",
        }}
      >
        Status
      </div>
      <div style={{ width: "100%" }}>
        <select className="custom-select"
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          style={{
            padding: "0px 12px 0px 12px",
            fontWeight: '500', fontSize: '14px',
            color: selectedStatus ? "#172B4D" : "#8790A1", // Green if selected, gray if not
          }}
        >
          <option value="">Select</option>
          {statusOptions.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    </div>)
  }
  const GateBased = () => {
    return (<div
      style={{
        width: "30%",
        gap: "8px",
      }}
    >
      <div
        style={{
          fontWeight: "500",
          fontSize: "13px",
          paddingBottom: '8px',
          color: "#172B4D",
        }}
      >
        Gate Based
      </div>
      <div>
        <SearchWithAPI onDropdownChange={handlegatebasedChange} apiUrl={apiUrl + "gate/autosuggestion"} params={{ location_id: selectedlocation != null ? selectedlocation.value : '' }} placeholder={"Select"} selectedOption={selectedGatebased} />
      </div>
    </div>)
  }

  const generateFields = () => {
    const fields = [];

    if (selectedType) {
      fields.push({ label: "Type", value: String(selectedType), value1: String(selectedType) });
    }
    if (selectedlocation) {
      fields.push({ label: "Location", value: String(selectedlocation.value), value1: String(selectedlocation.label) });
    }
    if (selectedDepart) {
      fields.push({ label: "Department", value: String(selectedDepart.value), value1: String(selectedDepart.label) });
    }
    if (selectedDatebasType) {
      fields.push({ label: "GateDate_type", value: String(selectedDatebasType), value1: String(selectedDatebasType) });
    }
    if (gatedateRange) {
      if (gatefrom_date && gateto_date) {
        const formattedFrom = formatDateToYMD(gatefrom_date);
        const formattedTo = formatDateToYMD(gateto_date);
        fields.push({ label: "Date based gate in & gate out", value: `${formattedFrom} - ${formattedTo}`, value1: `${formattedFrom} - ${formattedTo}` });
      }
    }
    if (dateRange) {
      if (from_date && to_date) {
        const formattedFrom = formatDateToYMD(from_date);
        const formattedTo = formatDateToYMD(to_date);

        fields.push({ label: "Created Date", value: `${formattedFrom} - ${formattedTo}`, value1: `${formattedFrom} - ${formattedTo}` });
      }
    }
    if (selectedpurpose) {
      fields.push({ label: "Purpose of visit", value: String(selectedpurpose.value), value1: String(selectedpurpose.label) });
    }
    if (selectedStatus) {
      fields.push({ label: "Status", value: String(selectedStatus), value1: String(selectedlocation.label) });
    }

    if (selectedmeetPerson) {
      fields.push({ label: "Meeting Person", value: String(selectedmeetPerson.value), value1: String(selectedmeetPerson.label) });
    }
    if (selectedOrgan) {
      fields.push({ label: "Organization", value: String(selectedOrgan.value), value1: String(selectedOrgan.label) });
    }
    if (selectedGatebased) {
      fields.push({ label: "Gate Based", value: String(selectedGatebased.value), value1: String(selectedGatebased.label) });
    }
    if (selectedMeetType) {
      fields.push({ label: "Meeting Type", value: String(selectedMeetType), value1: String(selectedMeetType) });
    }

    return fields;
  };
  // Assume locationList is an array of objects like: [{ label: 'Chennai', value: '292' }, {...}]
  const applyFieldsFromAPI = (fieldsFromAPI) => {
    if (!Array.isArray(fieldsFromAPI)) {
      console.error("Expected an array for fieldsFromAPI, but got:", fieldsFromAPI);
      return;
    }
    fieldsFromAPI.forEach((field) => {
      switch (field.label) {
        case "Location": {
          setSelectedlocation({ label: field.value1 ?? "", value: field.value });
          break;
        }
        case "Department": {
          setSelectedDepart({ label: field.value1 ?? "", value: field.value });
          break;
        }
        case "Purpose of visit": {
          setSelectedpurpose({ label: field.value1 ?? "", value: field.value });
          break;
        }
        case "Meeting Person": {
          setSelectedmeetPerson({ label: field.value1 ?? "", value: field.value });
          break;
        }
        case "Organization": {
          setSelectedOrgan({ label: field.value1 ?? "", value: field.value });
          break;
        }
        case "Gate Based": {
          setSelectedGatebased({ label: field.value1 ?? "Gate Based", value: field.value });
          break;
        }

        case "Type":
          console.log(field.value);
          setSelectedType(field.value);
          break;

        case "GateDate_type":
          console.log(field.value);
          setSelectedDatebasType(field.value);
          break;
        case "Status":
          setSelectedStatus(field.value);
          break;
        case "Meeting Type":
          setSelectedMeetType(field.value);
          break;
        case "Created Date": {
          const [from, to] = field.value.split(" - ");

          // Convert to Date objects if needed
          const fromDateObj = new Date(from);
          const toDateObj = new Date(to);
          // setFrom_date(from);
          // setTo_date(to);
          setDateRange([fromDateObj, toDateObj]);
          break;
        }
        case "Date based gate in & gate out": {
          const [from, to] = field.value.split(" - ");
          const fromDateObj = new Date(from);
          const toDateObj = new Date(to);
          console.log("fromDateObj");
          console.log(fromDateObj);
          console.log(toDateObj);
          setGateDateRange([fromDateObj, toDateObj]);
          break;
        }
        default:
          break;
      }
    });
  };

  const getIconByLabel = (label) => {
    switch (label) {
      case "Monthly Report":
      case "Weekly Report":
        return calendar;
      case "Purpose of visitor":
        return purpose;
      case "Visitor Based":
        return visitorbased;
      case "Meeting Person Based":
        return meeting;
      case "Gate Based":
        return gate;
      case "Location Based":
        return location;
      case "Department Based":
        return department;
      case "Organization Based":
        return organization;
      case "Checklist Failed":
        return checklist;
      case "Schedule Rejected":
        return scheduled;
      case "Max Time Spent":
        return time;
      case "Courier Company Based":
        return courier;
      case "Vehicle Type Based":
        return vehicletype;
      case "Driver Based":
        return driver;
      case "Vehicle Based":
        return vehiclebased;
      case "User Based":
        return user;
      case "Max time vehicle report":
        return time;
      case "Max time driver report":
        return time;
      default:
        return null; // or a default icon
    }
  };

  const [typeOptions] = useState([
    { label: "Visitor", value: "Visitor" },
    { label: "Vehicle", value: "Vehicle" },
    { label: "Courier", value: "Courier" },
  ]);
  const [meetTypeOptions] = useState([
    { label: "Direct", value: "Direct" },
    { label: "Schedule", value: "Schedule" },
  ]);
  const [datebaseTypeOptions] = useState([
    { label: "Gate in", value: "Gatein" },
    { label: "Gate out", value: "Gateout" },
  ]);
  const [statusOptions] = useState([
    { label: "Gate in", value: "Gate In" },
    { label: "Gate out", value: "Gate Out" },
  ]);
  const [isScannerActive, setIsScannerActive] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [gatedateRange, setGateDateRange] = useState([null, null]);
  const [from_date, to_date] = dateRange;
  const [gatefrom_date, gateto_date] = gatedateRange;

  const openModal = () => {
    console.log("open modal called");
    setIsOpen(true);
    setIsScannerActive(true);
  };

  const handleDepartChange = (option) => {
    console.log(option);
    setSelectedDepart(option);
  };
  const handlequickChange = (option) => {
    console.log(option);
    setSelectedquick(option);
    exportQuickGet(option);
  };
  const handleLocationChange = (option) => {
    console.log(option);
    setSelectedlocation(option);
    setSelectedGatebased('')
  };
  const handlemeetPersonChange = (option) => {
    console.log(option);
    setSelectedmeetPerson(option);
  };

  const handleVehicleTypeChange = (option) => {
    console.log(option)
    setSelectedVehicleType(option)
  };
  const handlepurposeChange = (option) => {
    console.log(option);
    setSelectedpurpose(option);
  };
  const handleOrganChange = (option) => {
    console.log(option);
    setSelectedOrgan(option);
  };
  const handlegatebasedChange = (option) => {
    console.log(option);
    setSelectedGatebased(option);

  };
  const handleResetChange = () => {
    setSelectedGatebased(null);
    setSelectedOrgan(null);
    setSelectedpurpose(null)
    setSelectedDepart(null)
    setSelectedPrev(null)
    setSelectedMy(null)
    setSelectedDatebasType('')
    setSelectedMeetType('')
    setSelectedStatus('')
    setSelectedType('Visitor')
    setSelectedmeetPerson(null)
    setSelectedlocation(null)
    setDateRange([null, null])
    setGateDateRange([null, null])

  };

  const getquickreport = async () => {
    try {
      const response = await getquickreportApi();
      console.log("API response:", response);

      if (response && response.success === true) {
        setreportOptions(response.suggestionlist);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const getTemplate = async () => {
    try {
      const response = await getTempalteApi();
      console.log("API response:", response);

      if (response.success === true) {
        setmyTemplates(response.templates);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };
  const getPreviousTemplate = async () => {
    try {
      const response = await getDownloadReportApi();
      console.log("API getPreviousTemplate response:", response);

      if (response.success === true) {
        setpreviousTemplates(response.templates);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };


  const getExportfield = async (id) => {
    try {
      const response = await getExportfieldApis(id);
      console.log("API response:", response);

      if (response.success === true) {
        // setmyTemplates(response.templates);
        applyFieldsFromAPI(response.template.fields);
        console.log("successful");
      } else {
        console.warn("Unexpected response or success flag missing:", response);
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const getExportdownlaod = async (id) => {
    try {
      const response = await getExportdownloadApis(id);
      console.log("API response:", response);

      if (!response.success || !response.url) {
        console.warn("Response is missing 'success' flag or 'url':", response);
        return;
      }

      const fileUrl = response.url;
      const fileName = response.file_name;

      // Fetch the file as a blob
      const fileResponse = await fetch(fileUrl);
      const blob = await fileResponse.blob();

      // Create a download link from blob
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName; // Optional: set your desired filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up blob URL
      window.URL.revokeObjectURL(blobUrl);

      console.log("Download triggered successfully.");
    } catch (error) {
      console.error("Download failed:", error);
      alert(`Download failed: ${error.message}`);
    }
  };






  const saveTempalte = async (visitorName, fieldsList) => {
    const bodydata = {
      application: "Gate",
      name: visitorName,
      fields: fieldsList,
    };
    try {
      const response = await savetempalteApi(bodydata);
      console.log("inside saveTempalte", response);

      console.log("inside saveTempalte");
      if (response.status === 400) {
        const errorData = response?.data?.error || {};

        const validationTemp = {
          name: errorData?.name?.[0] || "",
          fields: errorData?.fields?.[0] || "",
        };

        console.log("response.data.error...", errorData);
        console.log("validationTemp...", validationTemp);

        setValidations(validationTemp);
        console.log("validations...", validations);
      } else {
        if (response.data.success === true) {
          setSnackbarMessage(response.data.message);
          setSnackbarStatus(response.data.success);
          handleSnackbarShow();
          getTemplate();
          console.log("successful");
          setIsOpen(false);
        } else {
          console.warn("Unexpected response or success flag missing:", response);
        }
      }
    } catch (error) {
      console.error("Error in getquickreport:", error);
    }
  };

  const exportQuickGet = async (option) => {
    console.log(option.value);
    const response = await exportquickApi(option.value);
    console.log(response);
    if (response.status === 200) {
      console.log("inside sccuess1");
      if (response.data.success === true) {
        console.log("inside sccuess2");
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = response.data.file_name;

        // Convert Base64 to Blob
        downloadBase64File(base64String, fileName);
      }
    }
  };
  const exportApi = async () => {
    console.log("gatefrom_date");
    console.log(gatefrom_date);
    const apivalue = selectedType === 'Visitor'
      ? 'visitor'
      : selectedType === 'Vehicle'
        ? 'vehicle'
        : 'courier';
    const bodydata = {
      department_id: selectedDepart != null ? selectedDepart.value : '',

      location_id: selectedlocation != null ? selectedlocation.value : '',
      meeting_person: selectedmeetPerson != null ? selectedmeetPerson.value : '',
      purpose_of_visit: selectedpurpose != null ? selectedpurpose.value : '',
      organization: selectedOrgan != null ? selectedOrgan.value : '',
      gate: selectedGatebased != null ? selectedGatebased.value : '',
      meeting_type: selectedMeetType != null ? selectedMeetType : '',
      status: selectedStatus != null ? selectedStatus : '',
      fromCreatedDate: from_date ? formatDateToYMD(from_date) : '',
      toCreatedDate: to_date ? formatDateToYMD(to_date) : '',

      from_gate_in: selectedDatebasType === "Gatein" && gatefrom_date
        ? formatDateToYMD(gatefrom_date)
        : '',
      to_gate_in: selectedDatebasType === "Gatein" && gateto_date
        ? formatDateToYMD(gateto_date)
        : '',
      from_gate_out: selectedDatebasType === "Gateout" && gatefrom_date
        ? formatDateToYMD(gatefrom_date)
        : '',
      to_gate_out: selectedDatebasType === "Gateout" && gateto_date
        ? formatDateToYMD(gateto_date)
        : '',

      vehicletype_id: selectedVehicleType != null ? selectedVehicleType.value : "",

      from_gate_in: selectedDatebasType === "Gatein" && gatefrom_date ? new Date(gatefrom_date).toISOString().slice(0, 10) : "",
      to_gate_in: selectedDatebasType === "Gatein" && gateto_date ? new Date(gateto_date).toISOString().slice(0, 10) : "",
      from_gate_out: selectedDatebasType === "Gateout" && gatefrom_date ? new Date(gatefrom_date).toISOString().slice(0, 10) : "",
      to_gate_out: selectedDatebasType === "Gateout" && gateto_date ? new Date(gateto_date).toISOString().slice(0, 10) : "",
    };
    console.log(bodydata);

    const response = await exportdata(bodydata, apivalue);
    console.log(response);
    if (response.status === 200) {
      console.log("inside sccuess1");
      if (response.data.success === true) {
        console.log("inside sccuess2");
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = response.data.file_name;

        // Convert Base64 to Blob
        downloadBase64File(base64String, fileName);
      }
    }
    setSnackbarMessage(response.data.message);
    setSnackbarStatus(response.data.success);
    handleSnackbarShow();
  };

  useEffect(() => {
    getquickreport();
    getTemplate();
    getPreviousTemplate();
  }, []);

  function formatDateToYMD(date) {
    if (!(date instanceof Date)) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }


  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // fontFamily: "Epilogue",
        }}>
        <div>
          <TopBar currentName="report" />
        </div>
        <div
          style={{
            margin: "32px",
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "24px",
            }}>
            {selected === "Customized" && (
              <div>
                <img src={report} style={{ width: "340px", height: "200px" }} />
              </div>
            )}
            {selected === "Quick Report" && (
              <div>
                <img src={quick} style={{ width: "340px", height: "200px" }} />
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div
                style={{
                  borderRadius: "100px",
                  padding: "8px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}>
                <div
                  onClick={() => setSelected("Quick Report")}
                  style={{
                    borderRadius: "100px",
                    padding: "10px 24px",
                    gap: "8px",
                    backgroundColor: selected === "Quick Report" ? "#172B4D" : "#FFFFFF",
                    fontSize: "13.5px",
                    color: selected === "Quick Report" ? "#FFFFFF" : "#172B4D",
                    fontWeight: selected === "Quick Report" ? "600" : "500",
                    cursor: "pointer",
                  }}>
                  Quick Report
                </div>
                <div
                  onClick={() => setSelected("Customized")}
                  style={{
                    borderRadius: "100px",
                    padding: "10px 24px",
                    gap: "8px",
                    backgroundColor: selected === "Customized" ? "#172B4D" : "#FFFFFF",
                    fontSize: "13.5px",
                    color: selected === "Customized" ? "#FFFFFF" : "#172B4D",
                    fontWeight: selected === "Customized" ? "600" : "500",
                    cursor: "pointer",
                  }}>
                  Customized
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}>
                {selected === "Customized" && (
                  <div style={{ marginTop: "24px" }}>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "24px",
                        color: "#172B4D",
                      }}>
                      Customizable export
                    </div>
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#172B4D",
                        maxWidth: "480px",
                        marginTop: "8px",
                      }}>
                      Access your data effortlessly with customizable export options—streamline, optimize, and take control of your insights in just a few clicks.
                    </div>
                  </div>
                )}

                {selected === "Quick Report" && (
                  <div style={{ marginTop: "24px" }}>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "24px",
                        color: "#172B4D",
                      }}>
                      Quick Report
                    </div>
                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#172B4D",
                        maxWidth: "480px",
                        marginTop: "8px",
                      }}>
                      Our pre-designed report templates let you quickly download data, saving time and ensuring a smooth experience.
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Conditional rendering below */}
          {selected === "Customized" && (
            <div
              style={{
                borderRadius: "28px",
                padding: "24px 32px 32px 32px",
                backgroundColor: "#FFFFFF",
                marginBottom: "175px",
                marginRight: "175px",
                marginLeft: "175px",
                boxShadow: "0px 6px 13px 0px #0000001A, 0px 93px 37px 0px #00000003",
              }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "24px",
                    color: "#172B4D",
                  }}>
                  Export the report for efficient sharing
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}>
                  {/* My Templates Dropdown */}
                  <div style={{ position: "relative" }}>
                    <div
                      onClick={() => setOpenMy(!openMy)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "100px",
                        padding: "16px",
                        backgroundColor: "#F8F8F8",
                        gap: "5px",
                        cursor: "pointer",
                      }}>
                      <img src={mytemp} style={{ width: "16px" }} />
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#172B4D",
                        }}>
                        {selectedMy || "My templates"}
                      </div>
                      <img src={drop} style={{ marginLeft: "12px" }} />
                    </div>

                    {openMy && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          marginTop: "5px",
                          maxHeight: "250px", // <-- Set your preferred max height here
                          overflowY: "auto",
                          zIndex: 100,
                        }}>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={searchMy}
                          onChange={(e) => setSearchMy(e.target.value)}
                          style={{
                            padding: "8px 12px",
                            width: "100%",
                            border: "none",
                            borderBottom: "1px solid #eee",
                            outline: "none",
                          }}
                        />
                        {myTemplates
                          .filter((item) => item.label.toLowerCase().includes(searchMy.toLowerCase()))
                          .map((item, index) => (
                            <div
                              key={index}
                              onClick={() => {
                                setSelectedMy(item.label);
                                setOpenMy(false);
                                setSearchMy("");
                                getExportfield(item.value);
                              }}
                              style={{ padding: "10px 12px", cursor: "pointer" }}>
                              {item.label}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>

                  <div style={{ position: "relative" }}>
                    <div
                      onClick={() => setOpenPrev(!openPrev)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderRadius: "100px",
                        padding: "16px",
                        backgroundColor: "#F8F8F8",
                        gap: "5px",
                        cursor: "pointer",
                      }}>
                      <img src={previous} style={{ width: "16px" }} />
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#172B4D",
                        }}>
                        {selectedPrev || "Previous exports"}
                      </div>
                      <img src={drop} style={{ marginLeft: "12px" }} />
                    </div>

                    {openPrev && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          backgroundColor: "#fff",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          marginTop: "5px",
                          maxHeight: "250px", // <-- Set your preferred max height here
                          overflowY: "auto",
                          zIndex: 100,
                        }}>
                        <input
                          type="text"
                          placeholder="Search..."
                          value={searchPrev}
                          onChange={(e) => setSearchPrev(e.target.value)}
                          style={{
                            padding: "8px 12px",
                            width: "100%",
                            border: "none",
                            borderBottom: "1px solid #eee",
                            outline: "none",
                          }}
                        />
                        {previousTemplates
                          .filter((item) => item.label.toLowerCase().includes(searchPrev.toLowerCase()))
                          .map((item, index) => (
                            <div
                              key={index}
                              onClick={() => {
                                setSelectedPrev(item.label);
                                setOpenPrev(false);
                                setSearchPrev("");
                                getExportdownlaod(item.value);
                              }}
                              style={{ padding: "10px 12px", cursor: "pointer" }}>
                              {item.label}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div
                style={{
                  marginTop: "32px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}>
                <div style={{ display: "flex", flex: "10" }}>
                  <div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Type
                    </div>
                    <div style={{ width: "100%" }}>
                      {/* <Select
                      options={typeOptions}
                      value={typeOptions.find(option => option.value === selectedlocation)}
                      onChange={(selectedType) => setSelectedType(selectedType.value)}
                      styles={customStyles}
                      placeholder="Select"
                      isSearchable
                    /> */}
                      <select
                        className="custom-select"
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                        style={{
                          padding: "0px 12px 0px 12px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: selectedType ? "#172B4D" : "#8790A1", // Green if selected, gray if not
                        }}
                      >

                        {typeOptions.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div style={{ flex: "0.5" }}></div>

                  <div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Department
                    </div>
                    <SearchWithAPI onDropdownChange={handleDepartChange} apiUrl={adminApiUrl + "get_department"} params={{}} placeholder={"Select"} selectedOption={selectedDepart} />
                    {/* <select className="custom-select"
                    value={selectedDepart}
                    onChange={(e) => setSelectedDepart(e.target.value)}
                    style={{
                      padding: "0px 12px 0px 12px",
                      fontWeight: '500', fontSize: '14px',
                      color: selectedDepart ? "#172B4D" : "#8790A1", // Green if selected, gray if not
                    }}
                  >
                    <option value="">Select</option>
                    {departOptions.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select> */}
                  </div>

                  <div style={{ flex: "0.5" }}></div>

                  <div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Location
                    </div>
                    <SearchWithAPI onDropdownChange={handleLocationChange} apiUrl={adminApiUrl + "get_location"} params={{}} placeholder={"Select"} selectedOption={selectedlocation} />
                    {/* <div>
                    <select className="custom-select"
                      value={selectedlocation}
                      onChange={(e) => setSelectedlocation(e.target.value)}
                      style={{
                        padding: "0px 12px 0px 12px",
                        fontWeight: '500', fontSize: '14px',
                        color: selectedlocation ? "#172B4D" : "#8790A1", // Green if selected, gray if not
                      }}
                    >
                      <option value="">Select</option>
                      {locationOptions.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  </div>
                </div>

                <div style={{ display: "flex", flex: "10" }}>
                  <div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Date based gate in & gate out
                    </div>
                    {/* <div style={{ width: "100%" }}>
                      <select className="custom-select"
                        value={selectedDatebasType}
                        onChange={(e) => setSelectedDatebasType(e.target.value)}
                        style={{
                          padding: "0px 12px 0px 12px",
                          fontWeight: '500', fontSize: '14px',
                          color: selectedDatebasType ? "#172B4D" : "#8790A1", // Green if selected, gray if not
                        }}
                      >
                        <option value="">Select</option>
                        {datebaseTypeOptions.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ddd",
                        borderRadius: "10px",
                        height: "40px",
                        padding: "0 10px",
                        backgroundColor: "#fff",
                      }}>
                      <div style={{ flex: 1 }}>
                        <DatePicker
                          selectsRange={true}
                          startDate={gatefrom_date}
                          endDate={gateto_date}
                          onChange={(update) => setGateDateRange(update)}
                          placeholderText="DD-MM-YYYY"
                          className="react-datepicker__input-container"
                          wrapperClassName="w-100"
                          customInput={
                            <input
                              className="datepicker-custom-input"
                              style={{
                                borderLeft: "none",
                                // borderRight: "none",
                                // outline: "none",
                                // boxShadow: "none",
                                // width: "100%",
                                // height: "40px",
                                padding: "12px",
                                // fontSize: "14px",
                                borderRadius: "0px",
                              }}
                              placeholder="Select"
                            />
                          }
                        />
                      </div>

                      <select
                        value={selectedDatebasType}
                        onChange={(e) => setSelectedDatebasType(e.target.value)}
                        style={{
                          width: "120px", // 🔹 smaller width
                          marginLeft: "10px",
                          border: "none",
                          outline: "none",
                          backgroundColor: "transparent",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: selectedDatebasType ? "#172B4D" : "#8790A1",
                        }}>
                        <option value="">Select</option>
                        {datebaseTypeOptions.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div style={{ flex: "0.5" }}></div>

                  <div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Created Date
                    </div>
                    <div style={{ position: "relative", width: "100%" }} className="react-datepicker-wrapper">
                      <DatePicker
                        // className="custom-date"
                        selectsRange={true}
                        startDate={from_date}
                        endDate={to_date}
                        onChange={(update) => setDateRange(update)}
                        className="react-datepicker__input-container"
                        style={{
                          width: "100%",
                        }}
                        placeholderText="Select"
                        wrapperClassName="w-100"
                      />
                      <FaRegCalendarAlt
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#8790A1",
                        }}
                      />
                    </div>

                    {/* <div style={{ width: "100%" }}>
                    <input type="date" className="custom-date"
                      onChange={(e) => setSelectedDate(e.target.value)}
                      style={{
                        padding: "0px 12px",
                        fontWeight: '500',
                        fontSize: '14px',
                        color: selectedDate ? "#172B4D" : "#8790A1",
                      }} />
                  </div> */}
                  </div>

                  <div style={{ flex: "0.5" }}></div>

                  {selectedType === 'Vehicle' || selectedType === 'Courier' ? <StatusDropdown /> : (<div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Purpose of Visit
                    </div>
                    <div>
                      <SearchWithAPI onDropdownChange={handlepurposeChange} apiUrl={apiUrl + "visit/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={selectedpurpose} />
                    </div>
                  </div>)}

                </div>

                <div style={{ display: "flex", flex: "10" }}>
                  {selectedType === 'Vehicle' || selectedType === 'Courier' ? <GateBased /> : (<StatusDropdown />)}

                  <div style={{ flex: "0.5" }}></div>

                  {selectedType === 'Courier' ? null : selectedType === 'Vehicle' ? <div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}
                    >
                      Vehicle Type
                    </div>
                    <SearchWithAPI onDropdownChange={handleVehicleTypeChange} apiUrl={apiUrl + "vehicletype/autosuggestion"} params={{}} placeholder={"Select"} selectedOption={selectedVehicleType} />
                  </div> : (<div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Meeting person
                    </div>
                    <SearchWithAPI onDropdownChange={handlemeetPersonChange} apiUrl={apiUrl + "get_meeting_person"} params={{}} placeholder={"Select"} selectedOption={selectedmeetPerson} />
                  </div>)}

                  <div style={{ flex: "0.5" }}></div>

                  {selectedType === 'Courier' ? null : selectedType === 'Vehicle' ? <div style={{
                    width: "30%",
                    gap: "8px",
                  }}></div> : (<div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Organization
                    </div>
                    <div>
                      <SearchWithAPI onDropdownChange={handleOrganChange} apiUrl={apiUrl + "visitors/organization"} params={{}} placeholder={"Select"} selectedOption={selectedOrgan} />
                    </div>
                  </div>)}
                </div>

                <div style={{ display: "flex", flex: "10" }}>
                  {selectedType === 'Vehicle' || selectedType === 'Courier' ? null : (<GateBased />
                  )}
                  <div style={{ flex: "0.5" }}></div>

                  {selectedType === 'Vehicle' || selectedType === 'Courier' ? null : (<div
                    style={{
                      width: "30%",
                      gap: "8px",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        paddingBottom: "8px",
                        color: "#172B4D",
                      }}>
                      Meeting Type
                    </div>
                    <div style={{ width: "100%" }}>
                      <select
                        className="custom-select"
                        value={selectedMeetType}
                        onChange={(e) => setSelectedMeetType(e.target.value)}
                        style={{
                          padding: "0px 12px 0px 12px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: selectedMeetType ? "#172B4D" : "#8790A1", // Green if selected, gray if not
                        }}>
                        <option value="">Select</option>
                        {meetTypeOptions.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>)}

                  <div style={{ flex: "0.5" }}></div>

                  <div
                    style={{
                      width: "30%",
                      gap: "8px",
                      visibility: "hidden",
                    }}>
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        color: "#172B4D",
                      }}>
                      Type
                    </div>
                    <div>
                      <select className="custom-select">
                        <option>select</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  marginTop: "32px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <button
                  onClick={() => openModal()}
                  style={{
                    borderRadius: "100px",
                    border: "1px solid #2CBC53",
                    padding: "10px 16px",
                    display: "flex",
                    gap: "8px",
                    backgroundColor: "#FFFFFF",
                  }}>
                  <img src={download} style={{ width: "16px", color: "#2C8C53" }} />
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "13px",
                      color: "#2C8C53",
                    }}>
                    Save as template
                  </div>
                </button>

                <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                  <button
                    onClick={() => handleResetChange()}
                    style={{
                      borderRadius: "100px",
                      border: "1px solid #E5E5E5",
                      padding: "10px 28px",
                      backgroundColor: "#FFFFFF",
                      fontWeight: "700",
                      fontSize: "14px",
                      color: "#172B4D",
                    }}>
                    Reset
                  </button>

                  <button
                    onClick={() => exportApi()}
                    style={{
                      borderRadius: "100px",
                      border: "1px solid #E5E5E5",
                      padding: "10px 28px",
                      backgroundColor: "#2C8C53",
                      fontWeight: "700",
                      fontSize: "14px",
                      color: "#FFFFFF",
                    }}>
                    Export
                  </button>
                </div>
              </div>
            </div>
          )}

          {selected === "Quick Report" && (
            <div
              style={{
                borderRadius: "28px",
                padding: "32px",
                backgroundColor: "#FFFFFF",
                boxShadow: "0px 6px 13px 0px #0000001A, 0px 93px 37px 0px #00000003",
                marginBottom: "175px",
                marginRight: "175px",
                marginLeft: "175px",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "40px",
                }}>
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "32px",
                    color: "#172B4D",
                    marginBottom: "12px",
                  }}>
                  Quick Report Download
                </div>
                <div
                  style={{
                    fontWeight: "400",
                    fontSize: "13px",
                    color: "172B4D",
                    marginBottom: "16px",
                  }}>
                  Generate and save detailed reports with just a single click
                </div>

                <div
                  style={{
                    borderRadius: "100px",
                    padding: "10px 16px",
                    backgroundColor: "#E0FFED",
                    fontSize: "12px",
                    color: "#172B4D",
                    fontWeight: "400",
                    marginBottom: "24px",
                  }}>
                  Over {reportOptions.length} types of reports ready-to-download
                </div>

                <div className="custom-search">
                  <img src={searchs} style={{ width: "24px" }} />

                  <input
                    type="text"
                    placeholder="Search reports..."
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      fontWeight: "400",
                      fontSize: "13px",
                      color: "#172B4D",
                      border: "none",
                      outline: "none",
                      fontFamily: "Epilogue",
                      width: "100%",
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "28px",
                }}>
                <div
                  style={{
                    width: "35%",
                    border: "1px dashed #E5E5E5",
                    height: "0px",
                  }}></div>
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "16px",
                    color: "#172B4D",
                  }}>
                  Just a single click is enough!
                </div>
                <div
                  style={{
                    width: "35%",
                    border: "1px dashed #E5E5E5",
                    height: "0px",
                  }}></div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "12px", // optional spacing between items
                }}>
                {reportOptions
                  .filter((item) => item.label.toLowerCase().includes(searchTerm?.toLowerCase()))
                  .map((item, index) => (
                    <div
                      onClick={() => handlequickChange(item)} // <-- function triggered on click
                      key={index}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        gap: "12px",
                        alignItems: "center",
                        borderRadius: "16px",
                        padding: "12px",
                        border: "0.7px solid #F8F8F8",
                        backgroundColor: "#F8F8F8",
                        width: "calc(25% - 9px)", // 4 per row with gap accounted
                        boxSizing: "border-box",
                      }}>
                      <div>
                        <img src={getIconByLabel(item.label)} style={{ width: "24px" }} />
                      </div>
                      <div
                        style={{
                          fontWeight: "400",
                          fontSize: "12.5px",
                          color: "#172B4D",
                        }}>
                        {item.label}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {/*  */}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>

          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <TempalteModal
        isVisible={isOpen}
        validations={validations}
        onCancel={() => {
          console.log("Cancel tapped");
          setIsOpen(false);
          setValidations({
            name: "",
            fields: "",
          });
        }}
        onSave={(visitorName) => {
          console.log("Save tapped");
          console.log("Saving:", visitorName);
          const fieldsList = generateFields();
          console.log(fieldsList);
          saveTempalte(visitorName, fieldsList);
        }}
      />
    </div>
  );
};

export default Report;
